module.exports = __webpack_public_path__ + "4b0aa45f210c9c53455cc0814ca8ae1e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/policy/picmobile3.png
// module id = 1886
// module chunks = 0